import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const downloadFileService = {
  getHelpDocuments: function (options) {
    return api.get("/Storages", WithToken.headersToken({ params: options, responseType: 'blob' }, configuration.cookieName));
  },
};

export default downloadFileService;
